import palette from './palette';

const picker = {
  MuiPickersTextField: {
    styleOverrides: {
      root: {
        '& .MuiPickersSectionList-root.MuiPickersInputBase-sectionsContainer': {
          padding: '8px 0px',
        },
        '& .MuiPickersInputBase-sectionsContainer': {
          fontSize: '16px',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          height: '45px',
        },
        '& .MuiPickersInputBase-root.MuiPickersOutlinedInput-root': {
          background: palette.common.white,
          '&.Mui-error': {
            color: palette.red[100],
          },
          '& .MuiPickersOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&.Mui-focused:not(.Mui-error)': {
            '& .MuiPickersOutlinedInput-notchedOutline': {
              border: 'none',
            },
          },
        },
      },
    },
  },
};
export default picker;
